<template>
    <v-text-field
        class="p-[5px]"
        style="width: 33.3333%; display: inline-block"
        :rules="props.rules"
        :label="props.label"
        :required="props.required"
        :disabled="props.disabled"
        v-model="inputValue"
    ></v-text-field>
</template>

<script setup lang="ts">
    import { defineProps, computed, defineEmits } from 'vue'
    import { ValidationRule } from '@/model/types'

    const props = defineProps({
        modelValue: [String, Number, Object],
        rules: {
            type: Array as () => ValidationRule[] | undefined, // Updated type
            default: undefined,
        },
        label: String,
        required: Boolean,
        disabled: Boolean,
    })

    const emit = defineEmits(['update:modelValue'])

    const inputValue = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val),
    })
</script>
